
<div class="row">
    <div class="col-sm-12">
      <h3 class="sub-title alert alert-info text center">Fact Book for Sub Topic {{subTopicName}} </h3></div>
      <table class="row-border hover table table-striped display compact">

        <tbody>
        <tr><td>Sub Topic</td><td>{{subTopicName}}</td></tr>
        <tr><td>Topic</td><td>{{topicName}}</td></tr>
      </tbody>
      </table>
      <h4>Levels</h4>
      <table class="row-border hover table table-striped display compact">
      <tr *ngFor="let level of levels"><td>{{level['level_short_name']}} - {{level['level_country_name']}}</td></tr>
      </table>

  </div>
<div class="table-responsive" *ngIf="factList.length>0">
<span [appMath]="''"></span>
<table  datatable [dtOptions]="dtOptions" class="table table-striped display compact">
    <thead>
    <tr>
    <th>Truth</th>
    <th>Body</th>
    <th>Explanation</th>
    <th></th>

    </tr>
    </thead>

    <tbody>

    <tr *ngFor="let fact of factList;">
        <td>{{fact.truth? 'True' : 'False'}}</td>
       <td>

        <a [routerLink]="['/admin/fact/show',fact.server_fact_id]">
           {{fact.body}}
        </a>
        </td>

       <td>{{fact.explanation}}</td>
       <td><button class="btn btn-warning" (click)="removeFact(fact.server_fact_id)">X</button></td>

    </tr>

    </tbody>

</table>

</div>

<app-spinner *ngIf="(factList.length==0) && loading"></app-spinner>
<div *ngIf="(factList.length==0) && !loading" class="text-center">No Records Found </div>

<hr/>
<div class="text-center">
  <div class="btn-group" role="group">
    <a [routerLink]="['/admin/subtopic/show',server_subtopic_id]" class="btn btn-primary">Back to Sub Topic</a>
    <a [routerLink]="['/admin/fact/index']" class ="btn btn-primary"><i class="fa fa-list"> </i> All Facts</a>
    <a [routerLink]="['/admin/add/fact/to/subtopic/',server_subtopic_id]" class ="btn btn-primary"><i class="fa fa-plus"> </i> Add Fact</a>
    <a [routerLink]="['/admin/fact/new',0]" class ="btn btn-primary"> <i class="fa fa-plus"></i> Create New Fact</a>
</div>
</div>





